/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InvalidEntitiesDTO } from './invalid-entities-dto';


export interface EntityErrorsInvalidEntitiesDTO { 
    invalidEntities?: Array<InvalidEntitiesDTO>;
    validationResults?: { [key: string]: string; };
}

export class ClsEntityErrorsInvalidEntitiesDTO { 
    invalidEntities?: Array<InvalidEntitiesDTO> = undefined;
    validationResults?: { [key: string]: string; } = undefined;
}

